import React, { useState } from "react";
import { Copy, Check, Link as LinkIcon, Key } from "lucide-react";

const EventLinkGenerator = ({ eventId, pin }) => {
  const [withPin, setWithPin] = useState(false);
  const [copied, setCopied] = useState(false);

  const baseUrl = `${window.location.origin}/verify/`;
  const url = withPin
    ? `${baseUrl}${eventId}?pin=${pin}`
    : `${baseUrl}${eventId}`;

  const handleCopy = () => {
    navigator.clipboard.writeText(url);
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
  };

  return (
    <div className="p-4 rounded-2xl border shadow-sm bg-white max-w-lg w-full">
      <h2 className="text-lg font-semibold mb-2 flex items-center gap-2">
        <LinkIcon size={18} /> Share Event Link
      </h2>

      {/* Toggle for PIN */}
      <div className="flex items-center mb-3 gap-2">
        <input
          id="withPin"
          type="checkbox"
          checked={withPin}
          onChange={(e) => setWithPin(e.target.checked)}
          className="h-4 w-4 rounded border-gray-300 text-blue-600 focus:ring-blue-500"
        />
        <label htmlFor="withPin" className="text-sm flex items-center gap-1">
          <Key size={14} /> Include PIN
        </label>
      </div>

      {/* Generated link */}
      <div className="flex items-center bg-gray-50 border rounded-lg p-2">
        <input
          type="text"
          value={url}
          readOnly
          className="flex-1 bg-transparent text-sm outline-none"
        />
        <button
          onClick={handleCopy}
          className="ml-2 px-3 py-1 text-sm bg-blue-600 text-white rounded-md flex items-center gap-1 hover:bg-blue-700"
        >
          {copied ? (
            <>
              <Check size={14} /> Copied
            </>
          ) : (
            <>
              <Copy size={14} /> Copy
            </>
          )}
        </button>
      </div>
    </div>
  );
};

export default EventLinkGenerator;